import { MutationTree } from 'vuex'
import Project from "@/types/project/project"
import ProjectState from "@/store/modules/project/ProjectState"

export const mutations: MutationTree<ProjectState> = {
  setProject (state, project: Project) {
    state.project = project
  },
  setHasRunningTracking (state, params: {
    running: boolean,
    projectId: string
  }) {
    if (state.project) {
      if (state.project.id === params.projectId) {
        state.hasRunningTracking = params.running
      }
    } else {
      state.hasRunningTracking = false
    }
  }
}
